/** Vector re-creation of the supplied Baobab Adventures / bombacare leaf-circuit mark. */
export const Logo = ({ size = 44, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-label="Baobab Adventures" data-testid="brand-logo">
    <circle cx="50" cy="50" r="49" fill="#17A2A2" />
    <g stroke="#fff" strokeWidth="2.6" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M50 1v98" />
      <path d="M50 22 C34 36 30 54 37 70 C41 78 46 82 50 84 C54 82 59 78 63 70 C70 54 66 36 50 22Z" />
      <path d="M50 40 L40 30 M50 40 L60 30 M50 55 L37 44 M50 55 L63 44 M50 70 L39 60 M50 70 L61 60" />
      <path d="M28 8 v8 l-6 6 v40 M20 30 v28 l6 6 v20 M14 56 l6 -6 M35 4 v14" />
      <path d="M72 8 v14 l6 6 v26 M80 30 v20 l-6 6 v22 M86 44 l-6 6 M66 70 v12 l-4 4" />
    </g>
    <g fill="#fff">
      <circle cx="35" cy="18" r="2.6" /><circle cx="20" cy="30" r="2.6" /><circle cx="14" cy="56" r="2.6" /><circle cx="26" cy="44" r="2.6" />
      <circle cx="72" cy="8" r="2.6" /><circle cx="80" cy="30" r="2.6" /><circle cx="86" cy="44" r="2.6" /><circle cx="74" cy="56" r="2.6" /><circle cx="66" cy="70" r="2.6" />
    </g>
  </svg>
);

export const Wordmark = ({ sub = "ADVENTURES", dark = false }) => (
  <div className="flex items-center gap-3">
    <Logo size={40} />
    <div className="leading-none">
      <div className={`font-display text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-[#0A2540]"}`}>BAOBAB</div>
      <div className="text-[10px] font-bold tracking-[0.3em] text-[#17A2A2]">{sub}</div>
    </div>
  </div>
);
